// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"styles__Wrapper___1YCXI","Container":"styles__Container___R_zzQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Chess/RightMenu/ViewType/styles.scss
// module id = 1338
// module chunks = 0